export const EVENT_AFTER_LOADEDARTICLES = 'recombee-after-loadedArticles';
